export default __webpack_public_path__ + "static/media/03.8996d7c7.jpg";